/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosSearchHandlerInfo } from '../models/AptosSearchHandlerInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosSearchControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns AptosSearchHandlerInfo OK
     * @throws ApiError
     */
    public getAptosSearchHandler({
        term,
        filterBy = 'ALL',
    }: {
        term: string,
        filterBy?: 'ALL' | 'BLOCK' | 'TRANSACTION' | 'ADDRESS' | 'TOKEN' | 'MODULE' | 'COIN' | 'FUNGIBLE_ASSET' | 'COLLECTION' | 'OBJECT' | 'BATCH_TRX',
    }): CancelablePromise<Array<AptosSearchHandlerInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/search/handler',
            query: {
                'filterBy': filterBy,
                'term': term,
            },
        });
    }

}
